import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useAppContext from '../../../../context/useAppContext';
import { Dropdown } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { initialFilters, spec } from '../../../attendee/list/list';
import { handleSearchQuery } from '../../../manager/components/context';
import RateTemplate from '../../../../models/rateTemplate';

export function SeeAttendeesAction({ objects: selected, model = null, filterKey }) {
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();
    const history = useHistory();

    const urlFilteredObject = React.useMemo(() => {
        if (!selected || !event) return null;

        let _selected = selected instanceof Array ? selected : [selected];
        let url = `/ticket/O${organization.pk}/E${event.id}/manager/attendees`;

        const selectedIds = new Set(_selected.map(s => s.pk));

        const filters = filterKey ? { ...initialFilters, [filterKey]: selectedIds } : initialFilters;

        const search = Object.entries(handleSearchQuery(spec, filters))
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        return {
            pathname: url,
            search
        };
    }, [selected, filterKey, event, organization]);

    if (model === RateTemplate) return null;

    return (
        <Dropdown.Item
            disabled={!urlFilteredObject}
            onClick={() => {
                return history.push(urlFilteredObject);
            }}
        >
            {t('ticket.rates.seeAttendees')}
        </Dropdown.Item>
    );
}

SeeAttendeesAction.propTypes = {
    objects: PropTypes.array, //required
    model: PropTypes.func,
    filterKey: PropTypes.string.isRequired
};
